var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var MyChartDischargeSummaryCard_1;
import { Avatar, Card, Text, TextFontSize } from '@philips-internal/oswald-ui-components';
import { SelectionType, Size, Type } from '@philips-internal/oswald-ui-constants';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { eventListener, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { generateUUID, isFunction, isMobileResolution } from '@philips-internal/oswald-ui-utils';
import React, { PureComponent } from 'react';
import MyChartDischargeSummaryCardAPI from './my-chart-discharge-summary-card-api';
import './my-chart-discharge-summary-card.css';
import discharge from '../../assets/images/icons/discharge.svg';
import externalTransfer from '../../assets/images/icons/external-transfer.svg';
import SummaryType from '../../constants/summary-type';
const DISCHARGE_LABEL = 'patient.my.chart.label.discharge';
const EXTERNAL_TRANSFER_LABEL = 'patient.my.chart.label.external.transfer';
let MyChartDischargeSummaryCard = MyChartDischargeSummaryCard_1 = class MyChartDischargeSummaryCard extends PureComponent {
    constructor() {
        super(...arguments);
        this.handleClickSelection = () => {
            this.handleClickAllergie();
        };
        this.handleClickAllergie = () => {
            const { onClick, read, sequence, doctorName, classification, condition, serviceNumber } = this.props;
            if (isFunction(onClick)) {
                onClick(new ClickEvent({
                    value: {
                        classification,
                        condition,
                        doctorName,
                        read,
                        sequence,
                        serviceNumber,
                    }
                }));
            }
        };
    }
    static { this.propTypes = {
        attendanceLabel: string,
        className: string,
        contentClassName: string,
        dateLabel: string,
        encounterTypeLabel: string,
        onClick: eventListener,
        onSelect: eventListener,
        physicianLabel: string,
        uuid: string,
    }; }
    static { this.defaultProps = {
        selectable: false,
        selected: false,
        width: 12,
    }; }
    findTagLabel() {
        const { summaryType } = this.props;
        if (!summaryType) {
            return '';
        }
        return summaryType === SummaryType.DISCHARGE ? MessageService.translate(DISCHARGE_LABEL) : MessageService.translate(EXTERNAL_TRANSFER_LABEL);
    }
    findTagColorLabel() {
        const { summaryType } = this.props;
        if (!summaryType) {
            return Type.NEUTRAL;
        }
        return summaryType === SummaryType.DISCHARGE ? Type.SAFETY : Type.WARNING;
    }
    findAvatarImage() {
        const { summaryType } = this.props;
        if (!summaryType) {
            return '';
        }
        return summaryType === SummaryType.DISCHARGE ? discharge : externalTransfer;
    }
    hideImage() {
        const { summaryType } = this.props;
        return !summaryType ? true : false;
    }
    verifyMobileResolution() {
        if (isMobileResolution()) {
            return React.createElement(Avatar, { image: this.findAvatarImage(), size: Size.XSMALL, hideImage: this.hideImage() });
        }
        return React.createElement(Avatar, { image: this.findAvatarImage(), size: Size.XSMALL, hideImage: this.hideImage(), title: this.findTagLabel() });
    }
    render() {
        const { read, doctorName, dateReport, attendanceLabel, encounterTypeLabel, dateLabel, encounterType, physicianLabel, serviceNumber, width = MyChartDischargeSummaryCard_1.defaultProps.width, selected, selectable, selectionType = SelectionType.NONE, onSelect } = this.props;
        const notViewedClass = read === 'N' ? 'not-viewed' : '';
        const contentClass = 'card-content';
        return (React.createElement(Card, { uuid: generateUUID(), selectionType: selectionType, className: `my-chart-card ${contentClass} area-tag ${notViewedClass || ''}`, width: width, selected: selected, selectable: selectable, onSelect: onSelect },
            React.createElement("div", { className: `${contentClass}`, onClick: () => this.handleClickSelection() },
                React.createElement("div", { className: 'avatar-date-content' },
                    React.createElement("div", { className: `${contentClass} content-area-date` },
                        React.createElement("div", { className: "avatar-area area-date" },
                            React.createElement(Text, { size: TextFontSize.SMALL }, `${MessageService.translate(attendanceLabel)}:`),
                            React.createElement(Text, { bold: true, className: "subtitle" }, String(serviceNumber)))),
                    React.createElement("div", { className: `${contentClass} content-area-date` },
                        React.createElement("div", { className: "avatar-area area-date" },
                            React.createElement(Text, { size: TextFontSize.SMALL }, `${MessageService.translate(encounterTypeLabel)}:`),
                            React.createElement(Text, { bold: true, className: "subtitle" }, encounterType))),
                    React.createElement("div", { className: `${contentClass} content-area-date` },
                        React.createElement("div", { className: "avatar-area area-date" },
                            React.createElement(Text, { size: TextFontSize.SMALL }, `${MessageService.translate(dateLabel)}:`),
                            React.createElement(Text, { bold: true, className: "subtitle" }, dateReport))),
                    React.createElement("div", { className: contentClass },
                        React.createElement("div", { className: "avatar-area avatar-area-doctor" },
                            React.createElement(Text, { size: TextFontSize.SMALL }, `${MessageService.translate(physicianLabel)}:`),
                            React.createElement(Text, { bold: true, className: "subtitle" }, doctorName)))),
                React.createElement("div", { className: `${contentClass} area-tag` },
                    React.createElement("div", { className: "avatar-area" }, this.verifyMobileResolution())))));
    }
};
MyChartDischargeSummaryCard = MyChartDischargeSummaryCard_1 = __decorate([
    AwesomeComponent({ api: MyChartDischargeSummaryCardAPI, type: ComponentType.DATA_DISPLAY })
], MyChartDischargeSummaryCard);
export default MyChartDischargeSummaryCard;
//# sourceMappingURL=my-chart-discharge-summary-card.js.map